import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import * as url from '../../helpers/url_helper';
import apiFetch from '../../fetch';

// Crypto Redux States
import { inactiveUsersTypes } from './actionTypes';
import {
  getInactiveUsersListSuccess,
  getInactiveUsersListFail,
  activeUserFail,
} from './actions';

export const fetchInactiveUsers = async () => {
  console.log('Entró A mi SAGA');
  const path = url.API_URL;
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const query = `query{
    GetInactiveUsers(data: {userId: ${user.id || ''}}){
     USUARIO_NOMBRE
     USUARIO_APELLIDO
     USUARIO_CORREO
     ACCOUNT_NUMBER
     USUARIO_SEXO
     USUARIO_TELEFONO
     createdAt
     updatedAt
     CELULAR
     EMPRESA_ID
     USUARIO_ACTIVO
     INNOBOKEY
     id
   }
 }`;
  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.GetInactiveUsers;
};

function* inactiveSaga() {
  try {
    const response: Promise<any> = yield call(fetchInactiveUsers);
    yield put(getInactiveUsersListSuccess(response));
  } catch (error) {
    yield put(getInactiveUsersListFail(error));
  }
}

//UPDATE USER--------------
function* updateUserActive({ payload }: any): any {
  const path = url.API_URL;
  const { entities, data } = payload;

  const getAuthUser = localStorage.getItem('authUser');
  let userLogeado;
  if (getAuthUser) {
    userLogeado = JSON.parse(getAuthUser);
  }
  console.log(data, entities);

  const query = `mutation{
    activateUser(Users:{
      id: ${data.id},
      userId: ${userLogeado.id || ''}
      USUARIO_ACTIVO: true
      SUB_ENTITIES:"${entities.replace(/"/g, '\\"')}",
    }){
      USUARIO_NOMBRE
      USUARIO_ACTIVO
    }
  }`;

  try {
    const opts = {
      authRequired: false,
      body: {
        query,
      },
      method: 'POST',
    };

    const resp: any = yield call(apiFetch, path, opts);
    console.log('RESSSPPP', resp);

    const response: Promise<any> = yield call(fetchInactiveUsers);
    console.log('RESPONSE SAGAAA', response);
    yield put(getInactiveUsersListSuccess(response));
  } catch (error) {
    yield put(activeUserFail(error));
  }
}

function* InactiveUsersSaga() {
  yield takeLatest(inactiveUsersTypes.GET_INACTIVE_USERS, inactiveSaga);
  yield takeLatest(inactiveUsersTypes.ACTIVE_USER, updateUserActive);
}

export default InactiveUsersSaga;
